import { Box, Button, Grid, Typography } from "@mui/material";
import { TrackedTextField } from "src/theme/StyledFields";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useConfig } from "../auth";
import FormErrors from "../components/FormErrors";
import PasswordField from "../components/PasswordField";
import { signUp } from "../lib/allauth";
import ProviderList from "../socialaccount/ProviderList";

export default function Signup(props) {
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [password2Errors, setPassword2Errors] = useState([]);
  const [response, setResponse] = useState({ fetching: false, content: null });
  const config = useConfig();
  const hasProviders = config.data.socialaccount?.providers?.length > 0;

  function submit() {
    if (password2 !== password1) {
      setPassword2Errors([
        { param: "password2", message: "Password does not match." }
      ]);
      return;
    }
    setPassword2Errors([]);
    setResponse({ ...response, fetching: true });
    signUp({ email, username: email, password: password1 })
      .then((content) => {
        setResponse((r) => {
          return { ...r, content };
        });
      })
      .catch((e) => {
        // TODO: snackbar
        console.error(e);
        window.alert(e);
      })
      .then(() => {
        setResponse((r) => {
          return { ...r, fetching: false };
        });
      });
  }

  return (
    <Box p={2} mt={8}>
      <Grid
        item
        container
        fullWidth
        alignContent="center"
        justifyContent="space-between"
      >
        <Grid item>
          <Typography variant="h5">Sign-Up</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            {props?.onShowLogin ? (
              <Button size="small" onClick={() => props.onShowLogin()} data-attr="signup_show-login">
                or <b>Sign-In</b>
              </Button>
            ) : (
              <Link to="/account/login">
                or <b>Sign-In</b>
              </Link>
            )}
          </Typography>
        </Grid>
      </Grid>
      <FormErrors errors={response.content?.errors} />

      <form onSubmit={(e) => { e.preventDefault(); submit(); }} data-attr="signup-form_submit">
        <Grid container direction={"column"} gap={1}>
          <Grid item>
            <TrackedTextField
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              label="Email"
              data-attr="signup-form_field-email"
            />
            <FormErrors param="email" errors={response.content?.errors} />
          </Grid>
          <Grid item>
            <PasswordField
              fullWidth
              autoComplete="new-password"
              value={password1}
              onChange={(e) => setPassword1(e.target.value)}
              required
              label="Password"
              data-attr="signup-form_field-password"
            />
            <FormErrors param="password" errors={response.content?.errors} />
          </Grid>
          <Grid item>
            <PasswordField
              fullWidth
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
              label="Confirm Password"
              data-attr="signup-form_field-password-confirm"
            />
            <FormErrors param="password2" errors={password2Errors} />
          </Grid>

          <Button
            type="submit"
            variant={"contained"}
            disabled={
              email.indexOf("@") < 1 ||
              password1.length === 0 ||
              password2.length === 0 ||
              response.fetching
            }
            data-attr="signup-form_submit-button"
          >
            Register
          </Button>
        </Grid>
      </form>

      {hasProviders && (
        <Box mt={2}>
          <Typography variant="h5">Or...</Typography>
          <ProviderList callbackURL="/account/provider/callback" />
        </Box>
      )}
    </Box>
  );
}
